import React from 'react';

const TooltipContentScore = () =>
  <div className="rs-tooltip-big__content info-tooltip-content tooltip-content-score">
    Similarity score of published reaction that informed the predicted reaction based on their extended reaction centre (the atoms and bonds directly involved in the reaction and their immediate neighbourhood)
  </div>;

export default TooltipContentScore;
